module.exports = __webpack_public_path__ + "static_wap/img/cusp.3a7deee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cusp.png
// module id = ppnA
// module chunks = 1